<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  'reference': { type: Object, required: true }
})
</script>
<template>
  <div class="box">
    <div class="relative flex justify-between items-center">
      <!-- Horizontal line (behind circles) -->
      <div class="absolute top-5 left-0 right-0 h-1 bg-gray-300 z-0"></div>

      <!-- Step 1 -->
      <div class="relative z-10 flex flex-col items-center flex-1">
        <div class="w-10 h-10 rounded-full bg-m1 text-white flex items-center justify-center font-semibold">
          1
        </div>
        <span class="mt-2 text-sm text-gray-700 text-center dark:text-white">Quoted</span>
      </div>

      <!-- Step 2 -->
      <div class="relative z-10 flex flex-col items-center flex-1">
        <div
          class="w-10 h-10 rounded-full border-gray-300 dark:border-white flex items-center justify-center font-semibold "
          :class="[reference.accepted_at ? 'bg-m1 text-white' : 'text-gray-500 border-2 bg-white']">
          2
        </div>
        <span class="mt-2 text-sm text-gray-700 dark:text-white text-center">Accepted</span>
      </div>

      <!-- Step 3 -->
      <div class="relative z-10 flex flex-col items-center flex-1">
        <div
          class="w-10 h-10 rounded-full border-gray-300 dark:border-white flex items-center justify-center font-semibold"
          :class="[reference.invoice?.sent_at ? 'bg-m1 text-white' : 'text-gray-500 border-2 bg-white']">
          3
        </div>
        <span class="mt-2 text-sm text-gray-500 dark:text-white text-center">Invoiced</span>
      </div>

      <!-- Step 4 -->
      <div class="relative z-10 flex flex-col items-center flex-1">
        <div
          class="w-10 h-10 rounded-full border-gray-300 dark:border-white text-gray-500 flex items-center justify-center font-semibold"
          :class="[reference.resourced_at ? 'bg-m1 text-white' : 'text-gray-500 border-2 bg-white']">
          4
        </div>
        <span class="mt-2 text-sm text-gray-500  dark:text-white text-center">Resourced</span>
      </div>

      <!-- Step 5 -->
      <div class="relative z-10 flex flex-col items-center flex-1">
        <div
          class="w-10 h-10 rounded-full border-gray-300 dark:border-white flex items-center justify-center font-semibold "
          :class="[reference.invoice?.paid_at ? 'bg-m1 text-white' : 'text-gray-500 border-2 bg-white']">
          5
        </div>
        <span class="mt-2 text-sm text-gray-500 text-center  dark:text-white">Paid</span>
      </div>

    </div>
  </div>


</template>
